import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { ProductCardStock } from '../productsPanel/ProductCardStock'

export const StockOff = () => {

  const { productsDB } = useSelector(state => state)


  
  
  const [productSell, setProductSell] = useState([])
  
  const productsSellTrue = []
  
  useEffect(() => {
    productsDB.map(product =>{

      if(product.sell === "true"){
        productsSellTrue.push(product)

      }
  
    })
    // console.log(productsSellTrue)
    setProductSell(productsSellTrue)

  
  }, [])


      
    


  return (
    <div >
        

      <div  className="_productCardStock">
        {productSell.map(product =>
            
              <ProductCardStock  key={product.id} item={product} />
              
              )}
      </div>
        
        
    </div>
  )

}
